import type { AxiosResponse } from 'axios';
import api from './api';
import type { DismissibleNotice } from 'bc-model';

async function retrieveDismissibleNotices(): Promise<AxiosResponse<DismissibleNotice[]>> {
  return api.get(`/api/notices`);
}

async function updateDismissibleNotice(
  data: Omit<DismissibleNotice, 'accountId' | 'accountUuid'>
): Promise<AxiosResponse<DismissibleNotice>> {
  return api.post(`/api/notices`, data);
}

async function resetDismissibleNoticesByType(
  noticeKeys: string[]
): Promise<AxiosResponse<DismissibleNotice[]>> {
  return api.post(`/api/notices/reset`, { noticeKeys });
}

export { resetDismissibleNoticesByType, retrieveDismissibleNotices, updateDismissibleNotice };
